import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Badge } from "@material-ui/core";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import ForumIcon from "@material-ui/icons/Forum";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ScheduleIcon from "@material-ui/icons/Schedule";
import SecurityIcon from "@material-ui/icons/Security";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";

function ListItemLink(props) {
  const { icon, primary, to, className } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    <li>
      <ListItem button component={renderLink} className={className}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

const MainListItems = (props) => {
  const { drawerClose } = props;
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);
  const [connectionWarning, setConnectionWarning] = useState(false);

  const canAccess = permission => {
    const permissions = Array.isArray(permission) ? permission : [permission];
    return (
      user?.profile === "admin" ||
      permissions.some(item => user?.permissions?.includes(item))
    );
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  return (
    <div onClick={drawerClose}>
      {canAccess(["page:dashboard", "dashboard:list"]) && (
        <ListItemLink
          to="/"
          primary="Dashboard"
          icon={<DashboardOutlinedIcon />}
        />
      )}
      {canAccess(["page:connections", "connections:list"]) && (
        <ListItemLink
          to="/connections"
          primary={i18n.t("mainDrawer.listItems.connections")}
          icon={
            <Badge badgeContent={connectionWarning ? "!" : 0} colr="error">
              <SyncAltIcon />
            </Badge>
          }
        />
      )}
      {canAccess(["page:tickets", "tickets:list"]) && (
        <ListItemLink
          to="/tickets"
          primary={i18n.t("mainDrawer.listItems.tickets")}
          icon={<WhatsAppIcon />}
        />
      )}
      {canAccess(["page:ticket-audits", "ticket-audits:list"]) && (
        <ListItemLink
          to="/ticket-audits"
          primary="Auditoria de contatos"
          icon={<AssignmentTurnedInIcon />}
        />
      )}

      {canAccess(["page:internal-chat", "internal-chat:list"]) && (
        <ListItemLink
          to="/internal-chat"
          primary={i18n.t("mainDrawer.listItems.internalChat")}
          icon={<ForumIcon />}
        />
      )}

      {canAccess(["page:contacts", "contacts:list"]) && (
        <ListItemLink
          to="/contacts"
          primary={i18n.t("mainDrawer.listItems.contacts")}
          icon={<ContactPhoneOutlinedIcon />}
        />
      )}
      {canAccess(["page:quickAnswers", "quickAnswers:list"]) && (
        <ListItemLink
          to="/quickAnswers"
          primary={i18n.t("mainDrawer.listItems.quickAnswers")}
          icon={<QuestionAnswerOutlinedIcon />}
        />
      )}
      {canAccess(["page:scheduled-broadcasts", "scheduled-broadcasts:list"]) && (
        <ListItemLink
          to="/scheduled-broadcasts"
          primary="Agendamento em Massa"
          icon={<ScheduleIcon />}
        />
      )}
      {(canAccess(["page:users", "users:list"]) ||
        canAccess(["page:profiles", "profiles:list"]) ||
        canAccess(["page:tags", "tags:list"]) ||
        canAccess(["page:queues", "queues:list"]) ||
        canAccess(["page:settings", "settings:list"])) && (
        <>
          {canAccess(["page:users", "users:list"]) && (
            <ListItemLink
              to="/users"
              primary={i18n.t("mainDrawer.listItems.users")}
              icon={<PeopleAltOutlinedIcon />}
            />
          )}
          {canAccess(["page:profiles", "profiles:list"]) && (
            <ListItemLink
              to="/profiles"
              primary={i18n.t("mainDrawer.listItems.profiles")}
              icon={<SecurityIcon />}
            />
          )}
          {canAccess(["page:tags", "tags:list"]) && (
            <ListItemLink
              to="/tags"
              primary={i18n.t("mainDrawer.listItems.tags")}
              icon={<LocalOfferIcon />}
            />
          )}
          {canAccess(["page:queues", "queues:list"]) && (
            <ListItemLink
              to="/queues"
              primary={i18n.t("mainDrawer.listItems.queues")}
              icon={<AccountTreeOutlinedIcon />}
            />
          )}
          {canAccess(["page:settings", "settings:list"]) && (
            <ListItemLink
              to="/settings"
              primary={i18n.t("mainDrawer.listItems.settings")}
              icon={<SettingsOutlinedIcon />}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MainListItems;
